import React, { useEffect, useState } from 'react';
import { IconButton } from './ui/button';
import { PiArrowLeft, PiArrowRight, PiMinus, PiPlus } from 'react-icons/pi';

type NumberInputProps = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
  id?: string;
  'data-testid'?: string;
};

export const NumberInput = ({
  value,
  onChange,
  min = -100,
  max = 100,
  step = 1,
  className = '',
  'data-testid': dataTestId,
  ...inputProps
}: NumberInputProps) => {
  const [inputValue, setInputValue] = useState<string>(String(value));

  // Sync internal state when parent value changes
  useEffect(() => {
    // Only update if the value is different from the input (prevents cursor jump)
    if (String(value) !== inputValue) {
      setInputValue(String(value));
    }
    // eslint-disable-next-line
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setInputValue(val);

    // Allow empty or just '-' for typing
    if (val === '' || val === '-') return;

    const num = Number(val);
    if (!isNaN(num) && num >= min && num <= max) {
      onChange(num);
    }
  };

  const handleBlur = () => {
    // On blur, if input is empty or just '-', reset to last valid value
    if (inputValue === '' || inputValue === '-') {
      setInputValue(String(value));
    }
  };

  const handleDecrement = () => {
    const num = Number(inputValue) || 0;
    const newValue = Math.max(min, num - step);
    setInputValue(String(newValue));
    onChange(newValue);
  };

  const handleIncrement = () => {
    const num = Number(inputValue) || 0;
    const newValue = Math.min(max, num + step);
    setInputValue(String(newValue));
    onChange(newValue);
  };

  return (
    // <div
    //   className={`flex items-center justify-between border rounded-md px-3 py-2 w-full ${className}`}
    // >
    //   <input
    //     type='number'
    //     value={value}
    //     min={min}
    //     max={max}
    //     onChange={(e) => onChange(Number(e.target.value))}
    //     className='w-10 border-none outline-none bg-transparent text-base'
    //   />
    //   <div className='flex items-center gap-2'>
    //     <IconButton
    //       noHover
    //       noPadding
    //       type='button'
    //       onClick={handleDecrement}
    //       className='text-xl select-none'
    //       tabIndex={-1}
    //     >
    //       <PiMinus size={16} />
    //     </IconButton>
    //     <IconButton
    //       noHover
    //       noPadding
    //       type='button'
    //       onClick={handleIncrement}
    //       className='text-xl select-none'
    //       tabIndex={-1}
    //     >
    //       <PiPlus size={16} />
    //     </IconButton>
    //   </div>
    // </div>
    <div
      className={`flex items-center justify-between border rounded-md px-3 py-2 w-full ${className}`}
    >
      <IconButton
        noHover
        noPadding
        type='button'
        onClick={handleDecrement}
        className='text-xl select-none'
        tabIndex={-1}
      >
        {/* <PiMinus size={16} /> */}
        <PiArrowLeft size={16} />
      </IconButton>
      <input
        type='number'
        value={inputValue}
        min={min}
        max={max}
        onChange={handleInputChange}
        onBlur={handleBlur}
        className='w-full text-center border-none outline-none bg-transparent text-base'
        data-testid={dataTestId}
        {...inputProps}
      />
      <div className='flex items-center gap-2'>
        <IconButton
          noHover
          noPadding
          type='button'
          onClick={handleIncrement}
          className='text-xl select-none'
          tabIndex={-1}
        >
          {/* <PiPlus size={16} /> */}
          <PiArrowRight size={16} />
        </IconButton>
      </div>
    </div>
  );
};
